import * as formik from "formik";
import { Button, Form, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { AlertType } from "../../../types/AlertMessage";
import { useAlertContext } from "../../alert/AlertContext";
import { useAccountService } from "../../../hooks";

export const ForgottenPassword = () => {
  const alertContext = useAlertContext();
  const accountService = useAccountService();
  const navigate = useNavigate();
  const { Formik } = formik;

  const schema = yup.object({
    Email: yup.string().email().required(),
  });

  const handleFormSubmit = (values: any) => {
    accountService
      .ForgottenPassword(values.Email)
      .then((r) => {
        if (r === undefined) {
          alertContext.showAlert({
            message: "Error sending forgotten password request",
            type: AlertType.Error,
          });
        } else {
          alertContext.showAlert({
            message: "Password reset email sent",
            type: AlertType.Information,
          });

          navigate("/login");
        }
      })
      .catch((e) => {
        alertContext.showAlert({
          message: "Error sending forgotten password request",
          type: AlertType.Error,
        });
      });
  };

  return (
    <>
      <Formik
        validationSchema={schema}
        initialValues={{ Email: "" }}
        onSubmit={handleFormSubmit}>
        {({
          handleChange,
          values,
          errors,
          handleBlur,
          touched,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Modal.Header className="bg-secondary text-white">
              <Modal.Title>Forgotten Password</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group controlId="Username" className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter email"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.Email}
                  isInvalid={!!errors.Email && touched.Email}
                  name="Email"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.Email}
                </Form.Control.Feedback>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button type="submit">Submit</Button>
              <Button
                variant="danger"
                onClick={() => {
                  navigate("/login");
                }}>
                Cancel
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </>
  );
};
